<template>
  <v-dialog 
    v-model="activeMode"  
    max-width="800"
    @click:outside="closeForm()"
    :fullscreen="$vuetify.breakpoint.xs"
  >
    <template v-slot:activator="{ on }">
      <a v-on="on">62 города</a>
    </template>
    
    <v-card>
      <v-toolbar
        color="primary"
        dark
        flat
      >
        <v-toolbar-title>Список городов</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click="closeForm()">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text class="pt-3">
        <ul>
          <li v-for="item of cities" :key="item">
            {{ item }}
          </li>
        </ul>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" text @click="closeForm()">Закрыть</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'cities-list',

  data() {
    return {
      activeMode: false
    }
  },

  computed: {
    ...mapState('sites', ['cities'])
  },

  methods: {
    closeForm() {
      this.activeMode = false;
    }
  }
}
</script>

<style scoped>
ul {
  list-style: none;
  columns: 3;
  -webkit-columns: 3;
  -moz-columns: 3;
  column-fill: balance;
}
@media screen and (max-width: 599px) {
  ul {
    columns: 1;
    -webkit-columns: 1;
    -moz-columns: 1;
  }
}
</style>